import { BaseEntity } from "../base/base-entity";

export type Organization = {
  id?: string;
  slug: string;
  localGovCode: string;
  name: string;
  siteName: string;
  officialWebSiteURL: string;
  logoURL: string;
  gBizIdSetting?: GBizIDSetting;
};

export type GBizIDSetting = {
  orgId: string;
  activated: boolean;
  clientId?: string;
  createdAt: string;
  updatedAt: string;
};

export class OrganizationEntity extends BaseEntity {
  id: string;
  slug: string;
  localGovCode: string;
  name: string;
  siteName: string;
  officialWebSiteURL: string;
  logoURL: string;

  constructor(values: Organization) {
    super();
    this.id = values.id!;
    this.name = values.name;
    this.localGovCode = values.localGovCode;
    this.slug = values.slug;
    this.officialWebSiteURL = values.officialWebSiteURL;
    this.siteName = values.siteName;
    this.logoURL = values.logoURL;
  }

  static fromJSON(values: Organization) {
    return new OrganizationEntity(values);
  }
}
